import {autoinject} from 'aurelia-dependency-injection';
import {EntityManager, Repository} from "aurelia-orm";
import { Item } from '../entities/item';


@autoinject()
export class ClosedFolderService {
	repository: Repository;
	constructor(private entityManager: EntityManager) {
		this.repository = this.entityManager.getRepository(Item);
	}

	async list(): Promise<Array<Item>>{
		return this.repository.find("getclosedfolders");
	}
}